import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function submitEnquiry(payload) {
  const { data } = await axios.post(`${API}/enquiries`, payload, { timeout: 20000 });
  return data;
}

export function errorMessage(err) {
  const detail = err?.response?.data?.detail;
  if (Array.isArray(detail)) return detail.map((d) => d.msg.replace(/^Value error, /, "")).join(". ");
  if (typeof detail === "string") return detail;
  if (err?.code === "ECONNABORTED") return "The request timed out. Please check your connection and try again.";
  return "We couldn't send your enquiry right now. Please try again in a few minutes.";
}
